import React from 'react';
import {Typography} from 'antd'
const {Text} = Typography;
import './TemplateNameRibon.scss'
import {templateTypes} from '../../utils/constants/sequenceStages';

export default ({
                    templateName,
                    borderClassName = "border-general",
                    paddingClassName = "p-5",
                    className = "",
                    isClickable,
                    isFullBorder,
                    children
                }) => {
    let bgClassName = "bg-general";

    if (templateName) {
        const stage = Object.values(templateTypes).find(value => (templateName.includes(value.name) || (value.numberedName && (templateName.includes(value.numberedName)))));
        bgClassName = stage ? stage.bgClassName : null;
        borderClassName = stage ? stage.borderClassName : null;
    }

    let classNameFromProps = "";
    classNameFromProps = isClickable ? classNameFromProps.concat("clickable-ribbon ") : classNameFromProps.concat(" ");
    classNameFromProps = isFullBorder ? classNameFromProps.concat("border-template-ribbon ") : classNameFromProps.concat("border-left ");

    return (
        <div className={`${paddingClassName} ${borderClassName} ${classNameFromProps} ${className}`}>
            {children ?
                <React.Fragment>{children}</React.Fragment>
                :
                <Text type="secondary" className="flex-middle overline block">
                    {templateName}
                </Text>
            }
        </div>
    );
}